import { Pipe, PipeTransform } from '@angular/core';

/**
 * Single source of truth for how consent scopes ("What's shared") are shown to
 * users. Raw enum values (e.g. "FULL_RECORD") must never render in the UI;
 * stored values, API fields and on-chain data are intentionally left unchanged.
 */
const SCOPE_LABELS: Record<string, string> = {
  MOLST: 'MOLST form',
  LIVING_WILL: 'My advance directive & living will',
  CareTeamSummary: 'Care-team summary',
  GENERAL_INFO: 'General information',
  CRITICAL_INFO: 'Care-team summary only',
  CLINICAL_TRIAL: 'Clinical trial',
  MRI: 'MRI',
  REPORT: 'Report',
  FULL_RECORD: 'Full record',
};

/** Shared helper so components outside SharedModule (e.g. epic) can reuse the map. */
export function scopeLabel(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  const key = String(value).toUpperCase();
  if (SCOPE_LABELS[key]) {
    return SCOPE_LABELS[key];
  }
  // Unknown value: humanize instead of leaking the raw enum ("SOME_SCOPE" → "Some scope").
  const words = String(value).replace(/_/g, ' ').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

@Pipe({ name: 'scopeLabel' })
export class ScopeLabelPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    return scopeLabel(value);
  }
}
